<template>
  <v-card v-if="editLocationDetails">
    <v-toolbar dark color="white">
      <v-btn icon dark color="black" @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span style="color: black;" class="ml-8">Outlet Details</span>
      </v-toolbar-title>
    </v-toolbar>
    <div class="px-5 pt-2">
      <div class="grid-sidebar-locationedit">
        <span class="pt-2 warm-grey compact">
          Manager Name
          <span class="mandatory">*</span>
        </span>:
        <span style="height: 36px;">
          <v-text-field
            v-model="editLocation.managerName"
            dense
            class="compact"
          >{{ editLocation.managerName }}</v-text-field>
        </span>
      </div>
      <div class="grid-sidebar-locationedit">
        <span class="pt-2 warm-grey compact">
          Manager Email
          <span class="mandatory">*</span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-text-field
            type="email"
            v-model="editLocation.managerEmail"
            dense
            class="compact"
          >{{ editLocation.managerEmail }}</v-text-field>
        </span>
      </div>
      <div class="grid-sidebar-locationedit">
        <span class="pt-2 warm-grey compact">
          Manager Mobile
          <span class="mandatory">*</span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-text-field
            type="tel"
            :maxlength="10"
            dense
            v-model="editLocation.managerPhone"
            placeholder="Manager Mobile"
            class="compact"
            :rules="[
                  () => !!editLocation.managerPhone || 'This field is required',
                  () =>
                    (!!editLocation.managerPhone && editLocation.managerPhone.length == 10) ||
                    'Mobile must be 10 characters',
                ]"
            counter="10"
            requrired
          >{{ editLocation.managerPhone }}</v-text-field>
        </span>
      </div>
      <div class="grid-sidebar-locationedit" style="height: 32px;">
        <span class="pt-2 warm-grey compact">
          Outlet Name
          <span class="mandatory">*</span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-text-field
            v-model="editLocation.storeName"
            dense
            class="compact"
          >{{ editLocation.storeName }}</v-text-field>
        </span>
      </div>
      <div class="grid-sidebar-locationedit">
        <span class="pt-2 warm-grey compact">
          Outlet Address
          <span class="mandatory">*</span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-text-field v-model="editLocation.address" dense class="compact">
            {{
            editLocation.address
            }}
          </v-text-field>
        </span>
      </div>
      <div class="grid-sidebar-locationedit">
        <span class="pt-2 warm-grey compact">
          Category
          <span class="mandatory"></span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <!--<v-text-field
            v-model="editLocation.category"
            dense
            class="compact"
            style="text-transform:capitalize"
            >{{ editLocation.category }}</v-text-field
          >-->
          <v-select
            dense
            v-model="editLocation.category"
            :items="categories.categories"
            item-text="name"
            item-value="id"
            label
            persistent-hint
            return-object
            single-line
            @change="editLocation.subCategory = { id: null, name: null }"
          ></v-select>
        </span>
      </div>
      <div class="grid-sidebar-locationedit">
        <span class="pt-2 warm-grey compact">
          Subcategory
          <span class="mandatory">*</span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <!--<v-text-field
            v-model="editLocation.subCategory"
            dense
            class="compact"
            style="text-transform:capitalize"
            >{{ editLocation.subCategory }}</v-text-field
          >-->
          <v-select
            dense
            v-model="editLocation.subCategory"
            :items="categories.subcategories[editLocation.category.id]"
            item-text="name"
            item-value="id"
            label
            persistent-hint
            return-object
            single-line
          ></v-select>
        </span>
      </div>
      <div class="grid-sidebar-locationedit mt-2">
        <span class="pt-2 warm-grey compact">
          Opening Time
          <span class="mandatory"></span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-dialog
            ref="otdialog"
            v-model="otm"
            :return-value.sync="editLocation.tempOpeningTime"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="editLocation.tempOpeningTime"
                dense
                class="compact"
                readonly
                v-on="on"
                @change="changeOpeningTime()"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="otm"
              v-model="editLocation.tempOpeningTime"
              full-width
              format="24hr"
              @change="changeOpeningTime()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="otm = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.otdialog.save(editLocation.tempOpeningTime)"
              >OK</v-btn>
            </v-time-picker>
          </v-dialog>
        </span>
      </div>
      <div class="grid-sidebar-locationedit">
        <span class="pt-2 warm-grey compact">
          Closing TIme
          <span class="mandatory"></span>
        </span>
        <span>:</span>

        <span style="height: 36px;">
          <v-dialog
            ref="ctdialog"
            v-model="ctm"
            :return-value.sync="editLocation.tempClosingTime"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="editLocation.tempClosingTime"
                dense
                class="compact"
                readonly
                v-on="on"
                @change="changeClosingTime()"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="ctm"
              v-model="editLocation.tempClosingTime"
              full-width
              format="24hr"
              @change="changeClosingTime()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="ctm = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.ctdialog.save(editLocation.tempClosingTime)"
              >OK</v-btn>
            </v-time-picker>
          </v-dialog>
        </span>
      </div>
      <div class="grid-sidebar-locationedit" style="height: 32px;">
        <span class="pt-2 warm-grey compact">
          Legal Business Name
          <span class="mandatory"></span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-text-field
            v-model="editLocation.legalBusinessName"
            dense
            class="compact"
          >{{ editLocation.legalBusinessName }}</v-text-field>
        </span>
      </div>
      <div class="grid-sidebar-locationedit" style="height: 32px;">
        <span class="pt-2 warm-grey compact">
          Legal Business Address
          <span class="mandatory"></span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-text-field
            v-model="editLocation.legalBusinessAddress"
            dense
            class="compact"
          >{{ editLocation.legalBusinessAddress }}</v-text-field>
        </span>
      </div>
      <div class="grid-sidebar-locationedit" style="height: 32px;margin-bottom:150px">
        <span class="pt-2 warm-grey compact">
          GST Number
          <span class="mandatory"></span>
        </span>
        <span>:</span>
        <span style="height: 36px;">
          <v-text-field
            v-model="editLocation.gstNumber"
            dense
            class="compact"
          >{{ editLocation.gstNumber }}</v-text-field>
        </span>
      </div>
    </div>
    <v-row style="width:100%;">
      <v-col style="justify-content:center;text-align:center;">
        <v-btn color="gray" text large @click="close()" class="px-12">CANCEL</v-btn>
      </v-col>
      <v-col style="justify-content:center;text-align:center;">
        <v-btn
          id="submit"
          :disabled="
            !editLocation.managerName ||
              !editLocation.managerEmail ||
              !editLocation.managerPhone ||
              !editLocation.storeName ||
              !editLocation.address ||
              !editLocation.subCategory.id ||
              !editLocation.category.id
          "
          color="primary"
          depressed
          large
          @click="save()"
          class="px-12"
        >SAVE</v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import axios from "./../../plugins/axios";
import helper from "./../../utils/helper";

export default {
  name: "EditLocationDetails",
  props: ["editLocation", "editLocationDetails", "userId", "opened"],
  data: function() {
    return {
      categories: helper.categories(),
      ctm: false,
      otm: false,
      store: {
        nasid: 0,
        storeName: null,
        address: null
      },
      placeHolderOpeningTime: false,
      placeHolderClosingTime: false,
      locationOpeningTime: { display: null, value: null },
      locationClosingTime: { display: null, value: null },
      timings: [
        { value: "00:00:00", display: "00:00" },
        { value: "01:00:00", display: "01:00" },
        { value: "02:00:00", display: "02:00" },
        { value: "03:00:00", display: "03:00" },
        { value: "04:00:00", display: "04:00" },
        { value: "05:00:00", display: "05:00" },
        { value: "06:00:00", display: "06:00" },
        { value: "07:00:00", display: "07:00" },
        { value: "08:00:00", display: "08:00" },
        { value: "09:00:00", display: "09:00" },
        { value: "10:00:00", display: "10:00" },
        { value: "11:00:00", display: "11:00" },
        { value: "12:00:00", display: "12:00" },
        { value: "13:00:00", display: "13:00" },
        { value: "14:00:00", display: "14:00" },
        { value: "15:00:00", display: "15:00" },
        { value: "16:00:00", display: "16:00" },
        { value: "17:00:00", display: "17:00" },
        { value: "18:00:00", display: "18:00" },
        { value: "19:00:00", display: "19:00" },
        { value: "20:00:00", display: "20:00" },
        { value: "21:00:00", display: "21:00" },
        { value: "22:00:00", display: "22:00" },
        { value: "23:00:00", display: "23:00" }
      ],
      storeDetailsStatic: {
        locationCategory: null,
        locationSubCategory: null,
        locationOpeningTime: null,
        locationClosingTime: null,
        managerName: null,
        managerEmail: null,
        managerPhone: null,
        managerMobile: null,
        managerUserid: null
      }
    };
  },
  methods: {
    save: function() {
      this.store = {
        nasid: this.editLocation.nasid,
        storeName: this.editLocation.storeName,
        address: this.editLocation.address
      };
      //this.locationOpeningTime.value
      //this.locationClosingTime.value

      this.storeDetailsStatic = {
        locationCategory: this.editLocation.category.id,
        locationSubCategory: this.editLocation.subCategory.id,
        locationOpeningTime: this.editLocation.tempOpeningTime,
        locationClosingTime: this.editLocation.tempClosingTime,
        managerName: this.editLocation.managerName,
        managerEmail: this.editLocation.managerEmail,
        managerPhone: this.editLocation.managerPhone,
        legalBusinessName: this.editLocation.legalBusinessName,
        legalBusinessAddress: this.editLocation.legalBusinessAddress,
        gstNumber: this.editLocation.gstNumber
      };
      console.log(this.editLocation);
      if (
        this.placeHolderOpeningTime ||
        this.editLocation.tempOpeningTime.length >= "8"
      )
        this.storeDetailsStatic.locationOpeningTime = this.editLocation.locationOpeningTime;
      else
        this.storeDetailsStatic.locationOpeningTime =
          this.editLocation.tempOpeningTime + ":00";
      if (
        this.placeHolderClosingTime ||
        this.editLocation.tempClosingTime.length >= "8"
      )
        this.storeDetailsStatic.locationClosingTime = this.editLocation.locationClosingTime;
      else
        this.storeDetailsStatic.locationClosingTime =
          this.editLocation.tempClosingTime + ":00";
      var data = {
        store: this.store,
        details: this.storeDetailsStatic
      };

      axios
        .post("/wiom/updateUserLocation?userId=" + this.userId, data)
        .then(() => {
          axios
            .post(
              "/Client/updateStoreContactPersons" +
                "?i2e1-admin-token=" +
                helper.getCookie("token") +
                "&i2e1-admin-view-token=" +
                helper.getCookie("token"),
              {
                classification: "manager",
                user: {
                  userId:
                    this.editLocation.managerUserId &&
                    this.editLocation.managerUserId != ""
                      ? this.editLocation.managerUserId
                      : -1,
                  username: this.editLocation.managerEmail,
                  email: this.editLocation.managerEmail,
                  name: this.editLocation.managerName,
                  mobile: this.editLocation.managerPhone,
                  active: 0
                },
                nasid: this.editLocation.nasid,
                emailCheck: false,
                emailChanged: true
              }
            )
            .then(() => {
              this.editLocationDetails = false;
              this.$emit("save");
            });
        });
    },
    close: function() {
      this.$emit("close");
    },
    changeOpeningTime: function() {
      this.placeHolderOpeningTime = false;
    },
    changeClosingTime: function() {
      this.placeHolderClosingTime = false;
    }
  },
  watch: {
    otm: function() {
      this.placeHolderOpeningTime = false;
      this.placeHolderClosingTime = false;
    },
    ctm: function() {
      this.placeHolderClosingTime = false;
      this.placeHolderOpeningTime = false;
    }
  }
};
</script>
